<template>
    <div v-if="outlinkUrl" class="outlink-wrapper">
        <a
            :href="outlinkUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="btn bxs outlink"
            :class="[
                'btn-' + background,
                'btn-' + size
            ]"
            @click="$emit('click')"
        >
            {{ linkText }}
            <i v-if="linkIcon" :class="linkIcon" />
        </a>
        <template v-if="$isNorway()">
            <span
                v-if="!disableComplianceText"
                class="text-subtitle compliance-text"
                :class="alignComplianceText"
            >
                Annonselenke
            </span>
        </template>
        <template v-else-if="enableApplySecurelyText">
            <span
                class="text-subtitle compliance-text"
                :class="alignComplianceText"
            >
                {{ complianceText }}
            </span>
        </template>
    </div>
    <nuxt-link 
        v-else-if="graveyardUrl"
        :to="graveyardUrl" 
        class="btn bxs" 
        :class="['btn-' + background, 'btn-' + size]"
        @click="$emit('click')"
    >
        {{ linkText }}
        <i v-if="linkIcon" :class="linkIcon" />
    </nuxt-link>
</template>
<script>
export default {
    props: {
        background: {
            type: String,
            required: false,
            default: 'green'
        },
        size: {
            type: String,
            required: false,
            default: 'md'
        },
        icon: {
            type: String,
            required: false,
            default: null
        },
        hideIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        link: {
            type: Object,
            required: true,
        },
        text: {
            type: String,
            required: false,
            default: null
        },
        placement: {
            type: String,
            required: false,
            default: null
        },
        position: {
            type: Number,
            required: false,
            default: null
        },
        alignComplianceText: {
            type: String,
            required: false,
            default: 'center',
            validator(value) {
                return ['center', 'left', 'right'].includes(value);
            }
        },
        disableComplianceText: {
            type: Boolean,
            required: false,
            default: false
        },
        enableApplySecurelyText: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            graveyardLink: this.$store.state.settings.out_link_graveyard,
        };
    },
    computed: {
        redirectEnabled() {
            return this.link.data.redirect_enabled;
        },
        hasGraveyard() {
            return this.graveyardLink && this.$validateContentRelationship(this.graveyardLink);
        },
        outlinkUrl() {
            return this.redirectEnabled ? 
                this.getRedirectUrl() :
                null;
        },
        graveyardUrl() {
            return this.hasGraveyard ? 
                this.$prismic.linkResolver(this.graveyardLink) :
                null;
        },
        complianceText() {
            return this.$getApplySecurelyString(this.link);
        },
        linkText() {
            return this.text ?? this.$translate('cta_credit_card_list', 'Till ansökan');
        },
        linkIcon() {
            if (this.hideIcon) {
                return null;
            }
            return this.icon ?? 'fas fa-lock white';
        }
    },
    methods: {
        getRedirectUrl() {
            
            let url = '';
            if (this.link.type === 'lender') {
                url = `/out/${this.link.id}/`;
            }
            else {
                url = `/out/${this.link.uid}/`;
            }

            if (this.placement && this.position && this.position > 0) {
                return `${url}?placement=${this.placement}&position=${this.position}`;
            }

            if (this.placement) {
                return `${url}?placement=${this.placement}`;
            }

            if (this.position && this.position > 0) {
                return `${url}?position=${this.position}`;
            }

            return url;
        }
    }
};
</script>
<style lang="scss" scoped>
.outlink-wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    gap: 0.5rem;

    .compliance-text { 
        &.left {
            align-self: flex-start;
        }
        &.right {
            align-self: flex-end;
        }
        &.center {
            align-self: center;
        }
    }
}
</style>